import React, { useState, useEffect } from "react";
import { handleGetRequest } from "../../../services/GetTemplate";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import ApproveTransaction from "./ApproveTransaction";
import { FaEye } from "react-icons/fa";
import AuthTransactionDetails from "./AuthTransactionDetails";
import { useHistory } from "react-router-dom";

function AuthorizeTransaction() {
  const [group, setGroup] = useState([]);
  const [loading, setloading] = useState(false);
  const [selectedCustomers, setSelectedCustomers] = useState(null);
  const [displaySubDetailsModal, setDisplaySubDetailsModal] = useState(false);
  const [status, setstatus] = useState(false);
  const [authDetailId, setAuthDetailId] = useState([]);
  const [fileHeadId, setFileHeadId] = useState(null);
  const [disable, setDisable] = useState(null);
  const [rows, setRows] = useState(20);
  const [first, setFirst] = useState(0);

  const handlePageChange = (event) => {
    setFirst(event.first);
    setRows(event.rows);
  };
  const disableButton = fileHeadId === null ? true : false;

  let history = useHistory();

  const getGroup = async () => {
    setloading(true);
    const response = await handleGetRequest(
      "zbizgateway/authMatrixWorkFlow/authPendingRecords"
    );
    setGroup(response?.data);
    setloading(false);
  };

  useEffect(() => {
    getGroup();
  }, []);

  const handleAddNewSubDetails = (e, btnStatus) => {
    e.preventDefault();
    setstatus(btnStatus);
    setDisplaySubDetailsModal(true);
  };

  const onRowSelect = (event) => {
    setAuthDetailId(event.data.authDetailId);
    setFileHeadId(event.data.fileHeadId);
  };

  const onHide = (name) => {
    setDisplaySubDetailsModal(false);
  };

  const selectsIds = (rowData) => {
    setAuthDetailId(rowData?.authDetailId);
    setFileHeadId(rowData?.fileHeadId);
  };

  const actionTemplate = (rowData) => {
    return (
      <Button
        icon="pi pi-eye"
        onClick={() => selectsIds(rowData)}
        className="p-button-rounded p-button-info p-mr-2"
      />
    );
  };

  const callBackForTransactionDisable = (disable) => {
    setDisable(disable);
  };

  return (
    <>
      <Dialog
        visible={displaySubDetailsModal}
        style={{ width: "50vw" }}
        onHide={() => setDisplaySubDetailsModal(false)}
        header={`${
          status === "A" ? "Approve" : "Reject"
        } Authorize Transaction`}
      >
        <ApproveTransaction
          status={status}
          authDetailId={authDetailId}
          fileHeadId={fileHeadId}
          onHide={onHide}
          getGroup={getGroup}
          callBackForTransactionDisable={callBackForTransactionDisable}
        />
      </Dialog>

      <div className="page_header">
        <div
          className="Top__Btn"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div className="d_align">
            <i
              className="pi pi-arrow-circle-left mr-1"
              onClick={() => history.goBack()}
            />
            <h3 className="mod_heading">Authorize Transaction</h3>
          </div>
          <div className="GenerateDown__Btn p-mt-4">
            <Button
              disabled={disableButton}
              onClick={(e) => handleAddNewSubDetails(e, "A")}
              label="Approve"
              className="Btn__Transparent"
            />
            <Button
              disabled={disableButton}
              label="Reject"
              onClick={(e) => handleAddNewSubDetails(e, "R")}
              className="Btn__Dark"
            />
          </div>
        </div>
      </div>

      <div className="card p-datatable-sm">
        <DataTable
          dataKey="fileHeadId"
          // header="Authorize Transaction"
          value={group}
          loading={loading}
          selection={selectedCustomers}
          onSelectionChange={(e) => setSelectedCustomers(e.value)}
          onRowSelect={onRowSelect}
          paginator
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
          rows={rows}
          first={first}
          rowsPerPageOptions={[10, 20, 50, 100, 200]}
          onPage={handlePageChange}
          emptyMessage="No data found."
          sortMode="multiple"
          autoLayout
        >
          <Column filter field="batchId" header="Batch ID" sortable />
          <Column filter field="fileNmae" header="File Name" sortable />
          <Column
            filter
            field="fileUploadDate"
            header="File Upload Date"
            sortable
          />
          <Column
            filter
            field="fileUploadBy"
            header="File Upload By"
            sortable
          />
          <Column filter field="productName" header="Product Name" sortable />
          <Column filter field="noOfRecords" header="No Of Records" sortable />
          <Column filter field="totalAmount" header="Total Amount" sortable />
          <Column
            filter
            field="authLevelName"
            header="Auth Level Name"
            sortable
          />
          <Column body={actionTemplate} header="Action" />
        </DataTable>
      </div>
      {/* <div className="Down__Btn">
        <Button
          disabled={disableButton}
          label="Reject"
          onClick={(e) => handleAddNewSubDetails(e, "R")}
          className="Btn__Transparent"
        />
        <Button
          disabled={disableButton}
          onClick={(e) => handleAddNewSubDetails(e, "A")}
          label="Approve"
          className="Btn__Dark"
        />
      </div> */}
      {disable && disable === true ? (
        ""
      ) : (
        <AuthTransactionDetails fileHeadId={fileHeadId} />
      )}
    </>
  );
}

export default AuthorizeTransaction;
